import { render, staticRenderFns } from "./WebPlayerDialog.vue?vue&type=template&id=1d540dac&scoped=true&"
import script from "./WebPlayerDialog.vue?vue&type=script&lang=js&"
export * from "./WebPlayerDialog.vue?vue&type=script&lang=js&"
import style0 from "./WebPlayerDialog.vue?vue&type=style&index=0&id=1d540dac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../lib/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d540dac",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/rec-rich/lib/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1d540dac')) {
      api.createRecord('1d540dac', component.options)
    } else {
      api.reload('1d540dac', component.options)
    }
    module.hot.accept("./WebPlayerDialog.vue?vue&type=template&id=1d540dac&scoped=true&", function () {
      api.rerender('1d540dac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/main2/components/media/WebPlayerDialog.vue"
export default component.exports